export default "__VITE_ASSET__DsNZmMP6__"